<template>
    <div style="min-height: 60vh;" class="card d-flex">
        <simplebar class="card-body" style="max-height: 60vh">
            <ul id="metismenu" class="mm-collapse metismenu">
                <li v-for="item1 in menu_data" :key="'lvl1'+item1.id" :class="isActiveItem(item1.id)" class="has-arrow">
                    <a :id="'level'+item1.id" @contextmenu.prevent="clicker($event, item1.id)" @click="clickLevel(item1)">
                        <i v-if="item1.is_folder" class="fas fa-folder me-2"></i>
                        {{item1.name}}
                    </a>
                    <ul class="mm-collapse">
                            <li v-for="item2 in item1.sops" :key="'lvl2'+item2.id" class="has-arrow">
                                <a :id="'level'+item2.id" @contextmenu.prevent="clicker($event, item2.id)" @click="clickLevel(item2)">
                                    <i v-if="item2.is_folder" class="fas fa-folder me-2"></i>
                                    {{item2.name}} {{item2.id}}
                                </a>
                                <ul class="mm-collapse">
                                    <div v-if="item2.nodes">
                                        <li v-for="item3 in item2.nodes" :key="'lvl3'+item3.id" class="has-arrow">
                                            <a :id="'level'+item3.id" @contextmenu.prevent="clicker($event, item3.id)" @click="clickLevel(item3)">
                                                <i v-if="item3.is_folder" class="fas fa-folder me-2"></i>
                                                {{item3.name}}
                                            </a>
                                            <ul class="mm-collapse">
                                                <div v-if="item3.nodes"></div>
                                                <!--<div v-else>
                                                    <li>
                                                        <b-button size="sm" variant="outline-primary" @click="showAddDialog">Add Sop</b-button>
                                                    </li>
                                                </div>-->
                                                <div v-if="selected_sop_group == item3.id">
                                                    <li v-for="(sop, idx) in loaded_sops" :key="'document'+idx">
                                                        <a href="#/" @dblclick="fileDoubleClick(sop.id)">
                                                            <i class="far fa-file-alt"></i>
                                                            &nbsp;
                                                            {{sop.name}}
                                                        </a>
                                                    </li>
                                                </div>
                                            </ul>
                                        </li>
                                    </div>
                                    <!--<div v-else>
                                        <li>
                                            <b-button size="sm" variant="outline-primary" @click="showAddDialog">Add Sop</b-button>
                                        </li>
                                    </div>-->
                                    <div v-if="selected_sop_group == item2.id">
                                        <li v-for="(sop, idx) in loaded_sops" :key="'document'+idx">
                                            <a href="" @dblclick="fileDoubleClick(sop.id)">
                                                <i class="far fa-file-alt"></i>
                                                &nbsp;
                                                {{sop.name}}
                                            </a>
                                        </li>
                                    </div>
                                </ul>
                            </li>
                            <li v-for="(sop, idx) in loaded_sops" :key="'document'+idx">
                                <a href="#/" @click="fileDoubleClick(sop.id)">
                                    <i class="far fa-file-alt"></i>
                                    &nbsp;
                                    {{sop.name}}
                                </a>
                            </li>
                            <li v-if="is_loading">
                                <a href="">
                                    <i class="fas fa-spinner fa-spin"></i> Loading Documents
                                </a>
                            </li>
                            <li v-else-if="is_loading == false && loaded_sops.length == 0"><a href="">No Documents</a></li>
                    </ul>
                </li>
            </ul>
        </simplebar>

        <div v-if="menu_data.length == 0">
            <b-alert show variant="warning">
                <i class="fa fa-exclamation me-2"/>
                No Groups Found
            </b-alert>
        </div>
    </div>
</template>

<script>
// eslint-disable-next-line
import MetisMenu from "metismenujs/dist/metismenujs";
import simplebar from "simplebar-vue";
import { createPopper } from '@popperjs/core';
import { sopState, sopMethods } from '@/state/helpers.js'
import _ from 'lodash';
//import MenuItem from '@/components/widgets/misc/collapse-menu.vue'
export default {
    data:() => ({
        is_loading: false,
        rightClickMenu: null,
        right_click_item_id: null,
        showPopper: false,

        tree_data:[],
        expanded: true,
        depth: 1,
        menuRef: null,

        isnew_group:false,
        show_modal: false,
        modal_data:{
            id: -1,
            parent_id: null,
            name: '',
            prefix:'',
        }
    }),
    components:{
        //MenuItem,
        //eslint-disable-next-line
        simplebar
    },
    computed:{
        ...sopState,
        isLevelSelected(){
            //* Style the current selected level menu node
            var style = '';
            //if(this.returnLevels.length > 0 && this.selected_level != null){
                //if(this.returnLevels[0].id == this.selected_level.id){
                    style = 'text-decoration: underline !important; font-weight: bold;'
                //}
            //}
            return style;
        },
        menu_data(){
            var data = _.cloneDeep(this.tree_levels);
            data.forEach( element => {
                //TODO - Show list of documents for selected level
                if(this.selected_level != null){
                    if(this.selected_level.id == element.id){
                        element['selected'] = true;
                    }
                }
                element['parent'] = element.parent_id;
                element['text'] = element.name;
                element['is_folder'] = true;
            })
            
            data.forEach(ele => {
                let parent_id = ele.parent_id;
                if (parent_id == null) {
                //* Parent item -- do nothing
                }
                else {
                    //* If element is a child element, push to children array.
                    data.forEach(d => {
                        if (d.id === parent_id) {
                            let childArray = d.nodes;
                            if (!childArray) {
                                childArray = []
                            }
                            childArray.push(ele);
                            d.nodes = childArray;
                        }
                    })
                }
            });
            //* Remove duplicate elements
            data = data.filter(ele => ele.parent_id == null);
            if(data.length > 0){
                //*Set parent root as expanded;
                data[0]['opened'] = true;
            }
            return data;
        },
        tree_levels(){
            let data = [];
            if(this.sop_groups != null){
                data = this.sop_groups;
            }
            return data;
        },
        loaded_sops(){
            let data = [];
            if(this.sops != null){
                data = _.cloneDeep(this.sops.sop_types);
            }
            return data;
        },
        
    },
    methods:{
        ...sopMethods,
        initMetisMenu(){
            if(document.getElementById('metismenu')){
                this.menuRef = new MetisMenu("#metismenu", {toggle:true});
            }
        },
        isActiveItem(id){
            if(this.selected_sop_group == id && this.has_mounted == false){
                return 'mm-active'
            }
            else{
                return '';
            }
        },
        fileDoubleClick(id){
            this.$eventHub.$emit('openDocument', id);
        },
        showAddDialog(){
            //* tell documentList component to show add sop dialog
            this.$eventHub.$emit('addNewSop');
        },
        processLevels(levels){
            var data = _.cloneDeep(levels);
            data.forEach( element => {
                //TODO - Show list of documents for selected level
                if(this.selected_level != null){
                    if(this.selected_level.id == element.id){
                        element['selected'] = true;
                    }
                }
                element['parent'] = element.parent_id;
                element['text'] = element.name;
                element['is_folder'] = true;
            })
            
            data.forEach(ele => {
                let parent_id = ele.parent_id;
                if (parent_id == null) {
                //* Parent item -- do nothing
                }
                else {
                    //* If element is a child element, push to children array.
                    data.forEach(d => {
                        if (d.id === parent_id) {
                            let childArray = d.nodes;
                            if (!childArray) {
                                childArray = []
                            }
                            childArray.push(ele);
                            d.nodes = childArray;
                        }
                    })
                }
            });
            //* Remove duplicate elements
            data = data.filter(ele => ele.parent_id == null);
            if(data.length > 0){
                //*Set parent root as expanded;
                data[0]['opened'] = true;
            }
            return data;
        },
        clickLevel(payload){
            if(this.selected_sop_group != payload.id){
                this.is_loading = true;
                this.selectSopGroup(payload.id)
                .then(()=>{
                    this.loadSops(this.selected_sop_group)
                    .then(()=>{
                        this.is_loading = false;
                    })
                })
            }
        },

        newGroup(type, id){ //* id == the id of the right clicked element
            if(type === 'parent'){
                //* find element to get the parent_id
                let item = _.find(this.sop_groups, {id:id});
                if(item != undefined){
                    this.modal_data.parent_id = item.parent_id;
                }
            }
            else{
                this.modal_data.parent_id = id;
            }

            this.modal_data.name = '';
            this.modal_data.prefix = '';
            
            this.showModal();
        },
        editGroup(id){
            let group = _.find(this.sop_groups, {id: id});
            if(group != undefined){
                this.modal_data.id = group.id;
                this.modal_data.name = group.name;
                this.modal_data.prefix = group.prefix;
            }
            this.showModal();
        },
        save(){
            this.saveSopGroup(this.modal_data)
            .then(()=>{
                this.loadSopGroups()
                .then(()=>{
                    //this.tree_data = this.processLevels(this.tree_levels);
                    this.$bvModal.hide('groupModal');
                })
            });
        },

        showModal(){
            //TODO - remove unused items in actionHandler method
            return;
        },


        handleRightClick(payload){
            this.clicker(payload.event, payload.id);
        },
        //* popper stuff */
        clicker(event, id){
            //*set id to be used while saving
            this.right_click_item_id = id;

            this.hidePopper();

            this.$nextTick(()=>{
                this.showPopper = true;
                this.$nextTick(()=>{
                    //* Get ref to item element and popper elem
                    const element = document.querySelector('#level'+id)
                    const popper = document.querySelector('#treePopper')
                    this.$nextTick(()=>{
                        this.rightClickMenu = createPopper(element, popper,{
                            placement: 'bottom'
                        });
                        setTimeout(()=>{
                            //* Set focus to the popper element to make sure the blur even is fired
                            if(this.$refs.contextTreePopper != undefined){
                                this.$refs.contextTreePopper.focus();
                            }
                        }, 250);
                    });
                })
            })
        },
        hidePopper(){
            /*if(this.rightClickMenu != null){
                this.rightClickMenu.destroy();
            }*/
            this.showPopper = false;
        },
        actionHandler(type){
            if(type === 'add_child'){
                this.newGroup('child', this.right_click_item_id);
            }
            else if(type === 'add_parent'){
                this.newGroup('parent', this.right_click_item_id);
            }
            else if(type === 'edit'){
                this.editGroup(this.right_click_item_id);
            }
            else if(type === 'delete'){
                let params = { id: this.right_click_item_id };
                this.deleteSopGroup(params)
                .then(()=>{
                    this.loadSopGroups()
                    //.then(()=>{
                    //    this.tree_data = this.processLevels(this.tree_levels);
                        //this.$bvModal.hide('groupsModal');
                    //})
                })
            }
        },
    },
    mounted(){
        if(this.sop_groups == null){
            this.loadSopGroups()
            .then(()=>{
                setTimeout(()=>{
                    this.initMetisMenu();
                },600)
            })
        }
        else{
            setTimeout(()=>{
                this.initMetisMenu();
            },600 )
        }
        // else{
        //     this.tree_data = this.processLevels(this.tree_levels);
        //     alert(2)
        //     this.$nextTick(()=>{
        //         setTimeout(()=>{
        //             let elem = document.getElementById('metismenu');
        //             if(elem != null){
        //                 this.menuRef = new MetisMenu("#metismenu", {toggle:true});
        //             }
                    
        //         }, 600);
        //     })
        // }

        this.$eventHub.$on('clickedLevelItem', this.clickLevel);
    },
    beforeDestroy(){
        if(this.menuRef != null){
            this.menuRef.dispose();
        }
        this.$eventHub.$off('clickedLevelItem');
        //this.$eventHub.$off('setMenuItemData');
    }
}
</script>

<style scoped>



.metismenu {
  padding-left: 0;
}
.metismenu, .metismenu ul {
  list-style: none;
}
.metismenu li {
  position: relative;
}
.metismenu li a {
  display: block;
  padding-top: 5px;
  padding-bottom: 5px;
  color: #333;
  text-decoration: none;
  outline: 0 none;
}
.metismenu ul:before {
  position: absolute;
  border-left: 1px dotted #333;
  content: "";
  width: 30px;
  top: 25px;
  left: 5px;
  bottom: 17px;
}
.metismenu ul > li:before {
  position: absolute;
  border-top: 1px dotted #333;
  content: "";
  width: 30px;
  top: 13px;
  left: -26px;
}
li.active > a > span.fa-folder-o:before {
  content: "\f115" !important;
}




.dropIcon{
    
}


</style>